

var _angular = require('angular');

var _angular2 = _interopRequireDefault(_angular);

var _squid = require('squid');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

(function exportProviders(angular) {
    angular && angular.exportProviders(module, exports, __dirname, __filename);
})(window.angular);

_angular2['default'].module().factory('$footerFactory', function () {
    function isIndiaLegalEntity(auth) {
        // for PayPal India domestic launch legal entity should be 84
        // update footer with indian policy for this case
        return auth && auth.logged_in && auth.legalEntity === 84 || _squid.$locale.country === 'IN';
    }

    function is3PL() {
        return _squid.$config.threePLCountries && _squid.$config.threePLCountries.indexOf(_squid.$locale.country.toUpperCase()) > -1;
    }

    function isApac() {
        return _squid.$config.apacCountries && _squid.$config.apacCountries.indexOf(_squid.$locale.country) > -1;
    };

    function decidePolicyInformationContentKey(auth) {
        return (0, _squid.$elmo)('xo_legacy_3pl_issued_license_update', { 'ctx.COUNTRY': _squid.$locale.country }, 'Trmt_xo_legacy_3pl_issued_license_update_1').then(function (result) {
            var enabled = Boolean(result && result.treatment_name);

            if (enabled) {
                return 'footer.issued3plLicensePH';
            }

            if (isIndiaLegalEntity(auth)) {
                return 'footer.4plpolicyInformation';
            }

            if (is3PL()) {
                // Ramped to 100% since July 2023. Previous key footer.3plPolicyInformation is now replaced
                // Elmos have been removed and now we will always see the new key:
                // Key footer.issued3plLicense states that the legal license is already issued and live.
                return 'footer.issued3plLicense';
            }

            return 'footer.policyInformation';
        });
    }

    return {
        decidePolicyInformationContentKey: decidePolicyInformationContentKey,
        is3PL: is3PL,
        isApac: isApac
    };
});

_squid.$config;

_squid.$locale;

_squid.$elmo;


//////////////////
// WEBPACK FOOTER
// ../node_modules/xo-page-components/src/footer/factory.js
// module id = ../node_modules/xo-page-components/src/footer/factory.js
// module chunks = 0